import { SetStateAction, useState } from "react";
import { ModalWithButtons } from "./modal";
import { BlackButton, GreyButton } from "../button";
import { useTranslation } from "react-i18next";
import { NeutralColor } from "node-library/dist/colors";
import { FrontendUserInfo } from "node-library/dist/portal";
import { CustomTextInput } from "../inputs";

interface Props {
	user: FrontendUserInfo;
	disableBatchEdit: boolean;
	open: boolean;
	setOpen: React.Dispatch<SetStateAction<boolean>>;
	proceedAction: () => void;
}

export default function WorkflowSignatureModal(props: Props) {
	const { t: translation } = useTranslation();
	const [confirmText, setConfirmText] = useState<string>("");

	const modal: React.ReactNode = (
		<ModalWithButtons
			headerText={""}
			open={props.open}
			setOpen={props.setOpen}
			buttons={[
				<GreyButton
					key="delete-sample-cancel-button"
					id="delete-sample-cancel-button"
					children={translation("Cancel")}
					onClick={() => {
						props.setOpen(false);
					}}
				></GreyButton>,
				<BlackButton
					key="delete-sample-proceed-button"
					id="delete-sample-proceed-button"
					children={translation("Sign")}
					disabled={confirmText !== props.user.firstName}
					onClick={() => {
						setTimeout(() => props.proceedAction(), 1);
						props.setOpen(false);
					}}
				></BlackButton>,
			]}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "5px",
					alignItems: "center",
					textAlign: "center",
					marginTop: "-10px",
				}}
			>
				<div className="modal-body-icon delete-sample-icon"></div>

				<div className="typography-body-02 typography-bold">
					{translation("SignAndProceed")}
				</div>
				<div
					className="typography-caption"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("WorkflowSignatureDescription")}
				</div>
				{props.disableBatchEdit ? (
					<div
						className="typography-caption"
						style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
					>
						{translation("WorkflowDisableBatchEditMessage")}
					</div>
				) : (
					<></>
				)}
				<CustomTextInput
					id={`delete-modal-confirm-textbox`}
					key={`delete-modal-confirm-textbox`}
					value={confirmText}
					setValue={setConfirmText}
					placeholder={props.user.firstName}
					type="text"
					required={true}
				></CustomTextInput>
			</div>
		</ModalWithButtons>
	);

	return modal;
}
